<template>
  <ContentSection
    :class="[
      {
        '!pt-0':
          prevComponent === 'consulting' ||
          prevComponent === 'consulting_two_people',
      },
      {
        '!pb-0':
          !nextComponent ||
          nextComponent === 'consulting' ||
          nextComponent === 'consulting_two_people',
      },
    ]"
  >
    <div
      class="py-14 sm:py-28"
      :class="
        prevComponent === 'consulting' ||
        prevComponent === 'consulting_two_people' ||
        nextComponent === 'consulting' ||
        nextComponent === 'consulting_two_people'
          ? 'bg-blue-10'
          : 'bg-gradient-to-t from-blue-50/40 to-blue-10/40'
      "
    >
      <Container indent="center">
        <div class="grid grid-cols-1 gap-8 sm:gap-12 md:grid-cols-3 lg:gap-18">
          <!-- IMAGE -->
          <div class="h-full w-full">
            <AppImage
              v-if="teamMember.image"
              :alt="
                $i18n.locale === 'fr'
                  ? teamMember.image.alt_fr
                  : teamMember.image.alt
              "
              class="aspect-[370/295] w-full rounded-sm object-cover object-left md:aspect-[25/33.5]"
              loading="lazy"
              :style="`object-position: ${teamMember.image.focus_css};`"
              :src="teamMember.image"
            />
          </div>
          <!-- TEXT -->
          <div class="px-4 pb-1 md:col-span-2 md:px-0">
            <div>
              <h2
                v-if="data.heading"
                class="mb-5 max-w-title text-3xl font-medium sm:mb-8 sm:text-5xl"
                v-html="$replaceHtmlTags(data.heading)"
              />
              <p class="text-md font-medium sm:text-lg">
                {{ teamMember.title }}
              </p>
              <p class="text-md sm:text-lg">
                {{ teamMember.job_title }}
              </p>
            </div>
            <div class="my-5 flex flex-wrap gap-x-9 gap-y-2 sm:my-8">
              <a
                :href="`tel:${teamMember.phone}`"
                class="flex w-fit items-center gap-3 text-md text-blue-800 transition-colors hover:text-blue-dark sm:text-lg"
              >
                <PhoneIcon class="w-4 shrink-0" />
                {{ teamMember.phone }}
              </a>

              <a
                :href="`mailto:${teamMember.email}`"
                class="flex w-fit items-center gap-3 text-md text-blue-800 transition-colors hover:text-blue-dark sm:text-lg"
              >
                <MailOutlinedIcon class="mt-1 w-[1.125rem] shrink-0" />
                {{ teamMember.email }}
              </a>
            </div>

            <AppButton
              v-if="data.link"
              :target="data.target?.value"
              :to="data.link"
              class="w-fit"
            >
              {{ data.link_text }}
            </AppButton>
          </div>
        </div>
      </Container>
    </div>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
  nextComponent: { type: String, default: null },
  prevComponent: { type: String, default: null },
})

const teamMember = computed(() => props.data?.team_member || {})
</script>
